// import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import React, { useState, useEffect, useContext, useRef, useMemo } from "react";

import { AuthContext } from "../store/ContextStore";
import api from "../utils/api";
import { TEAM_PROFILE } from "../constants/routes";

import { useNavigate, useParams } from "react-router-dom";
import { AllCommunityModule, ColDef, ColGroupDef, ModuleRegistry, themeBalham, themeQuartz } from 'ag-grid-community';


import TeamstatTable from '../components/teamcomponents/TeamstatTable';
import TeamRecordsView from '../components/teamcomponents/TeamRecordsView';
import TeamSeasonHighsView from '../components/teamcomponents/TeamSeasonHighsView';
import TeamGameLogsview from '../components/teamcomponents/TeamGameLogsView';
import TeamStreaksView from '../components/teamcomponents/TeamStreaksView';

ModuleRegistry.registerModules([AllCommunityModule]);



type TabCode = "stats" | "records" | "season" | "logs" | "streks";
interface TeamData {
  SportCode: string,
  TeamName: string,
  TeamCode: string,
  stat_mapping: {
    [key: string | number]: any;
  }
}


  

const TeamDashboard = () => {

    
  const [activeTab, setActiveTab] = useState<TabCode>("stats");
  const { team } = useContext(AuthContext);

  const [TeamData, setTeamData] = useState<TeamData | null | undefined>();
  const [logoUrl, setLogoUrl] = useState<null | string>(null);

  const {sportsCode, teamCode} = useParams();

  const tabs: { tabName: string, tabCode: TabCode ,  errorContext: string;}[] = [
    { tabName: "Team Statistics", tabCode: "stats" ,    errorContext: "Error fetching player statistics.",
},
    { tabName: "Team Records", tabCode: "records",    errorContext: "Error fetching player records.",
 },
    { tabName: "Season  Highs", tabCode: "season",     errorContext: "Error fetching season and career highs.",
 },
    { tabName: "Team Game Log", tabCode: "logs",    errorContext: "Error fetching player game logs.",
 },
    { tabName: "Team Streaks", tabCode: "streks",    errorContext: "Error fetching player streak data.",
 },
  ];

  const handleTabChange = (tabCode: TabCode) => {
    
    setActiveTab(tabCode);
  }


  useEffect(() => {
  async function fetchPlayerBasicInfo() {
    if ( !sportsCode) return;
    
    try {
      const res = await api.post(TEAM_PROFILE, {
        SportCode: sportsCode,
        TeamCode: teamCode,
      });
      console.log("profile res",res)
      // Set basic player data for other tabs to use
      setTeamData({
        SportCode: sportsCode,
        TeamName: res.data.TeamName,
        TeamCode: res.data.TeamCode || '',
        stat_mapping: res.data.stat_mapping || {}
      });
      
    } catch (error) {
      console.error("Error fetching basic player info:", error);
      // Even on error, set basic info so tabs can function
      setTeamData({
        SportCode: sportsCode,
        TeamName: '',
        TeamCode: '',
        stat_mapping: {}
      });
    }
  }

  fetchPlayerBasicInfo();
}, [ sportsCode, teamCode]);

useEffect(() => {
    const newUrl = "https://premier.athlytesports.com/assets/images/teams"
    setLogoUrl(`${newUrl}/${Math.round(parseInt(TeamData?.TeamCode ?? "0"))}.png`)
    console.log("urL : " ,`${newUrl}/${Math.round(parseInt(TeamData?.TeamCode ?? "0"))}.png`);
  }, [TeamData]);


  return (
    
    <div className="overflow-x-auto w-full flex flex-col gap-2">
      <div className=""
        style={{
          background: `${team.colorCode} url('/playerbanner.png') center/cover no-repeat`,
        }}
      >
        <div className="flex flex-col gap-2 w-full px-[54px] py-6">
          <div className="flex flex-row gap-4 mt-16 text-white">
            <div className="flex flex-col justify-end">
              <div className="flex flex-row items-center gap-4">
              {/* {JSON.stringify(team)} */}
                {logoUrl && <img src={logoUrl} alt="" className="w-[3.5rem] rounded-lg" />}
                <div className="flex flex-row items-center gap-2">
                  <p>{TeamData?.TeamName}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-2 px-[54px]" style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}>
          {tabs.map((tab) => (
            <div key={tab.tabCode}>
              <button
                onClick={() => handleTabChange(tab.tabCode)}
                className={`px-4 py-2 transition-all duration-300 text-white font-primary font-normal text-xs ${activeTab === tab.tabCode ? "border-b-2" : "hover:bg-gray-300"}`}
              >
                {tab.tabName.toUpperCase()}
              </button>
            </div>
          ))}
        </div>
      </div>

          <div className="px-[54px] py-[38px]">
              {activeTab === "stats" && <TeamstatTable setTeamData={setTeamData} />}
              {activeTab === "records" && <TeamRecordsView TeamData={TeamData}/>}
              {activeTab === "season" && <TeamSeasonHighsView TeamData={TeamData}/>}
              {activeTab === "logs" && <TeamGameLogsview TeamData={TeamData}/>}
              {activeTab === "streks" && <TeamStreaksView TeamData={TeamData}/>}
           </div>   
    </div>
  );
};

export default TeamDashboard;